module.exports = __webpack_public_path__ + "./fonts/spotify-bold.ttf";